<template>
  <div class="mine-coupon">
    <img class="mine-coupon-bg" v-if="coupon.status===2" src="../../assets/images/coupon-pass.png" alt="coupon" />
    <img class="mine-coupon-bg" v-else src="../../assets/images/coupon.png" alt="coupon" />
    <div class="mine-coupon-desc">
      <span :class="{ 'small-font': ('' + coupon.value).length >= 3 }">
        {{ coupon.discountType === 1 ? coupon.value : coupon.value * 10 }}
      </span>
      <i>{{ coupon.discountType === 1 ? '元' : '折'}}</i>
    </div>
    <div class="mine-coupon-detail">
      <h5>{{ coupon.subtitle }}</h5>
      <p>有效期至：<span v-for="(item, index) in coupon.useEnd" :key="index">{{item}}</span></p>
      <p>{{ coupon.remark }}</p>
    </div>
    <div @click="toUse" v-if="coupon.status!==2" class="mine-coupon-use">立即使用</div>
  </div>
</template>

<script>
import os from '@edu-fe/os'

export default {
  name: 'coupon',

  props: ['coupon', 'isVipUser'],

  watch: {
    coupon : {
      handler(e) {
        if (typeof e.useEnd === 'string') {
          e.useEnd = e.useEnd.replace(/-/g,'.')
          let eArr = e.useEnd.split(' ')
          eArr[1] = eArr[1].substr(0, eArr[1].length-3)
          e.useEnd = eArr
        }
      },
      immediate: true,
      deep: true
    }
  },

  computed: {
    isApp () {
      if (os.type === 'app') {
        if (os.name === 'android' || os.name === 'ios') {
          return true
        }
      }
      return false
    }
  },

  methods: {
    jumpTo (target, data) {
      if (this.isApp) {
          return os.sdk.view.goto(target, data)
      }
      this.$router.push({
        path: `/${target}`,
        query: data
      })
    },

    toUse () {
      if (this.coupon.value >= 100) {
        // 跳转优惠券
        return this.jumpTo('vip')
      }
      if (this.isVipUser || this.coupon.remark === "移动大礼包") {
        return this.jumpTo('recommend')
      }
      if (this.coupon.applyResult) {
        return this.jumpTo('sign-up', { courseId: this.coupon.applyResult })
      } else {
        if (this.isApp) {
          return this.jumpTo('recommend')
        }
        this.$router.push({
          path: '/preferential'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../../style/main";

$global-width: 750;

.mine-coupon {
  position: relative;
  margin: 0 auto;
  width: rem(696);
  // height: rem(212);
  &-use {
    position: absolute;
    height: rem(200);
    width: rem(90);
    right: rem(-8);
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    padding: rem(15) rem(30);
    box-sizing: border-box;
    color:#fff;
    font-weight: bolder;
    letter-spacing:rem(5);
    line-height: 1.3;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    height: 100%;
    width: 100%;
  }

  &-desc {
    position: absolute;
    top: 0;
    bottom: 0;
    left: rem(65);
    margin: auto 0;
    height: rem(126);
    text-align: center;

    span {
      display: inline-block;
      color: #F48F00;
      font-size: rem(90);
      font-weight: 500;
      line-height: rem(126);
      // margin-right: rem(10);

      &.small-font {
        font-size: rem(60);
      }
    }

    i {
      color: #F48F00;
      font-size: rem(40);
      font-weight: bold;
    }
  }

  &-detail {
    position: absolute;
    top: 0;
    bottom: 0;
    left: rem(240);
    margin: auto 0;
    height: rem(120);
    width: rem(375);
    color: #666;
    font-size: rem(24);
    // line-height: rem(28);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    span {
      &:first-child{
        margin-right: rem(20);
      }
    }
    h5 {
      color: #F48F00;
      font-size: rem(26);
      line-height: rem(28);
      margin-bottom: rem(20);
    }
    p {
      margin-bottom: rem(20);
    }
  }
}
</style>
